/* TODO: it is dummy function just to fill object with empty data - it will be later removed */

import { VariantContent } from "src/types/VariantContent";

function getSelectedFilters(type: VariantContent) {
  return (function () {
    switch (type) {
      case `videos`:
        return [
          { type: `difficulty`, title: `moderate`, value: `moderate` },
          { type: `focus`, title: `flexibility`, value: `flexibility` },
          { type: `style`, title: `hatha`, value: `hatha` },
        ];
      case `instructors`:
        return [
          { type: `favorite`, title: `favorite`, value: `true` },
          { type: `country`, title: `England`, value: `en` },
          { type: `style`, title: `hatha`, value: `hatha` },
        ];
      case `asanas`:
        return [
          { type: `difficulty`, title: `moderate`, value: `moderate` },
          { type: `focus`, title: `flexibility`, value: `flexibility` },
          { type: `style`, title: `hatha`, value: `hatha` },
        ];
    }
  })();
}

export default getSelectedFilters;
